import { i18n } from '@/plugins/i18n';
import { themeView } from '@/themes/views';

export default {
  path: 'events',
  name: 'events',
  meta: {
    plugin: 'events',
  },
  component: themeView('Shell'),
  children: [
    {
      path: '',
      name: 'categories-list',
      component: themeView('EventsCategories'),
      meta: {
        plugin: 'events',
        hide_navbar: true,
      },
    },
    {
      path: 'thankyou',
      name: 'thankyou',
      component: themeView('BookingThankYou'),
      props: true,
      meta: {
        page_title: i18n.global.tc('Thank You'),
        breadcrumbItems: ['categories-list', 'thankyou'],
        plugin: 'events',
      },
    },
    {
      path: 'waitingzone',
      name: 'waitingzone',
      component: themeView('TicketWaitZone'),
      props: true,
      meta: {
        page_title: i18n.global.tc('Please wait ...'),
        breadcrumbItems: ['customer-event-list', 'thankyou'],
        plugin: 'events',
      },
    },
    {
      path: ':category',
      name: 'customer-event-list',
      component: themeView('EventsList'),
      meta: {
        plugin: 'events',
        hide_navbar: true,
      },
    },
    {
      path: 'event/:slug',
      name: 'customer-event-details',

      component: themeView('EventDetails'),
      meta: {
        page_title: i18n.global.tc('Event details'),
        breadcrumbItems: ['customer-event-list', 'customer-event-details'],
        plugin: 'events',
      },
    },
    {
      // new_era only: the Secure payment page. A legacy theme resolves this
      // to a redirect back to the event page (#160247).
      path: 'event/:slug/pay',
      name: 'new-era-pay',
      component: themeView('Pay'),
      meta: {
        page_title: i18n.global.tc('Secure payment'),
        plugin: 'events',
      },
    },
    {
      path: 'not-found',
      name: 'page-404',
      component: themeView('NotFound'),
    },
  ],
};
